import { useEffect, useRef, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  CircularProgress,
  IconButton,
  FormControlLabel,
  RadioGroup,
  Radio,
  Tooltip,
} from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import { motion } from "framer-motion";
import SelectableSearch from "../../Base/views/SelectableSearch";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CheckIcon from "@mui/icons-material/Check";
import { toast } from "react-toastify";
import ArrowBackButton from "../../Base/views/ArrowBackButton";
import { AddVisitorsAction } from "../../../../store/Employee/Visitors/Action";
import { DeleteEmailTokenHelper } from "../../Ancillary/EmailToken/helper/EmailTokenHelper";
import { v4 as uuidv4 } from "uuid";
import SelectableLimitSearch from "../../Base/views/SelectableLimitSearch";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {sendWhatsAppTextMessageHelper} from "../../Whatsapp/helper/TemplateHelper";

const TypeformReplica = ({
  employeesData,
  handleEmployees,
  handleVisitorReasons,
  visitorReasonData,
  mode,
  visitorFormData,
  setVisitorFormData = () => {},
  setCheckInSuccess = () => {},
  domain,
  userId,
  region_fk,
  isSingleOrg,
  visitorOrgData,
  handleOrg,
  handleReset,
  visitorTypePopup,
  whatsAppFlow
}) => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);
  const { visitorLoading, visitorsExtraSettingData } = useSelector(
    (state) => state?.EmployeeReducer?.VisitorsReducer
  );
  const { whatsappConfigData } = useSelector((state) => state?.AncillaryReducer?.WhatsappConfigReducer);
  const [sendWhatsappMsg, setSendWhatsappMsg] = useState("no");
  const [slideMessage, setSlideMessage] = useState(null);
  const [downloadToken, setDownloadToken] = useState("");
  const [downloadName, setDownloadName] = useState("");
  const checkDisabled = (value) => visitorTypePopup?.type === "Guest" ? true : visitorTypePopup?.type === "Guest" && value ? true : false;

  const steps = [
    {
      id: "name",
      label: "Your Name",
      component: (
        <TextField
          label="Enter Your Full Name"
          fullWidth
          variant="standard"
          size="large"
          value={visitorFormData?.name}
          disabled={checkDisabled(visitorFormData?.name)}
          onChange={(e) => {
            setVisitorFormData((prevData) => ({
              ...prevData,
              name: e.target.value,
            }));
            setErrors({});
          }}
          error={!!errors.name}
          helperText={errors.name || ""}
          FormHelperTextProps={{
            sx: {
              marginTop: "-10px",
            },
          }}
          InputProps={{
            disableUnderline: true,
            sx: {
              fontSize: "28px",
              height: "50px",
              marginBottom: "20px",
              "&:before": {
                borderBottom: "2px solid #000",
              },
              "&:hover:not(.Mui-disabled):before": {
                borderBottom: "2px solid #1976d2",
              },
            },
          }}
          sx={{
            "& .MuiInput-root": {
              fontSize: "28px",
              height: "50px",
              borderBottom: "2px solid black",
              "&:hover:not(.Mui-disabled):before": {
                borderBottom: "2px solid blue",
              },
            },
            "& .MuiInput-underline:after": {
              borderBottom: "2px solid #1976d2",
            },
            "& .MuiInputLabel-root": {
              fontSize: "26px",
            },
          }}
        />
      ),
      validate: () => visitorFormData.name.trim() !== "",
      show: true,
    },
    {
      id: "phone-number",
      label: "Your Phone Number",
      component: (
        <TextField
          label="Enter Phone Number"
          placeholder="9876543210"
          variant="standard"
          autoFocus
          type="number"
          fullWidth
          value={visitorFormData?.contactno}
          disabled={checkDisabled(visitorFormData?.contactno)}
          onChange={(e) => {
            if (e.target.value.length <= 10) {
              setVisitorFormData((prevData) => ({
                ...prevData,
                contactno: e.target.value,
              }));
              setErrors({});
            }
          }}
          error={!!errors.contactno}
          helperText={errors.contactno || ""}
          FormHelperTextProps={{
            sx: {
              marginTop: "-10px",
            },
          }}
          InputProps={{
            disableUnderline: true,
            sx: {
              fontSize: "28px",
              height: "50px",
              marginBottom: "20px",
              "&:before": {
                borderBottom: "2px solid #000",
              },
              "&:hover:not(.Mui-disabled):before": {
                borderBottom: "2px solid #1976d2",
              },
            },
          }}
          sx={{
            "& .MuiInput-root": {
              fontSize: "28px",
              height: "50px",
              borderBottom: "2px solid black",
              "&:hover:not(.Mui-disabled):before": {
                borderBottom: "2px solid blue",
              },
            },
            "& .MuiInput-underline:after": {
              borderBottom: "2px solid #1976d2",
            },
            "& .MuiInputLabel-root": {
              fontSize: "26px",
            },
          }}
        />
      ),
      validate: () => /^\d{10}$/.test(visitorFormData.contactno),
      show: true,
    },
    {
      id: "org",
      label: "Which organization are you visiting?",
      component: (
        <SelectableSearch
          label="Select Organization"
          value={visitorFormData?.multiple_org_configuration_fk}
          disabled={checkDisabled(visitorFormData?.multiple_org_configuration_fk?.multiple_org_configuration_pk)}
          loading={() => handleOrg()}
          fieldLabel="org_name"
          variant={"outlined"}
          name="multiple_org_configuration_fk"
          size="small"
          onChangeEvent={(e, v) => {
            setVisitorFormData((prev) => ({ ...prev, [e]: v }));
            setErrors({});
          }}
          data={visitorOrgData}
          error={!!errors.multiple_org_configuration_fk}
          helperText={errors.multiple_org_configuration_fk || ""}
          styles={{
            "& .MuiOutlinedInput-root, & .MuiInputBase-root": {
              border: "none",
              borderBottom: "2px solid black",
              borderRadius: 0,
              fontSize: "28px",
              height: "50px",
              marginTop: "5px"
            },
            "& .MuiOutlinedInput-notchedOutline, & fieldset": {
              border: "none",
            },
            "&:hover .MuiOutlinedInput-root, &:hover .MuiInputBase-root": {
              borderBottom: "2px solid black",
            },
            "& .MuiInputLabel-root": {
              fontSize: "26px",
            },
          }}
          renderOption={(props, option) => (
            <li {...props} style={{ fontSize: "18px", padding: "5px 15px" }}>
              {option.org_name}
            </li>
          )}
        />
      ),
      validate: () => visitorFormData?.multiple_org_configuration_fk,
      show: !isSingleOrg,
    },
    {
      id: "person-to-meet",
      label: "Whom are you meeting?",
      component: (
        <SelectableLimitSearch
          label="Select Person"
          value={visitorFormData?.employee_id}
          disabled={checkDisabled(visitorFormData?.employee_id?.visited_employee_fk)}
          loading={() => handleEmployees()}
          fieldLabel="name"
          variant={"outlined"}
          name="employee_id"
          size="small"
          onChangeEvent={(e, v) => {
            setVisitorFormData((prev) => ({ ...prev, [e]: v }));
            setErrors({});
          }}
          data={employeesData}
          error={!!errors.employee_id}
          helperText={errors.employee_id || ""}
          styles={{
            "& .MuiOutlinedInput-root, & .MuiInputBase-root": {
              border: "none",
              borderBottom: "2px solid black",
              borderRadius: 0,
              fontSize: "28px",
              height: "50px",
              marginTop: "5px"
            },
            "& .MuiOutlinedInput-notchedOutline, & fieldset": {
              border: "none",
            },
            "&:hover .MuiOutlinedInput-root, &:hover .MuiInputBase-root": {
              borderBottom: "2px solid black",
            },
            "& .MuiInputLabel-root": {
              fontSize: "26px",
            },
          }}
          renderOption={(props, option) => (
            <li {...props} style={{ fontSize: "18px", padding: "5px 15px" }}>
              {option.name}
            </li>
          )}
        />
      ),
      validate: () => visitorFormData?.employee_id,
      show: true,
    },
    {
      id: "purpose-of-visit",
      label: "Purpose of Visit",
      component: (
        <SelectableSearch
          label="Select Purpose"
          value={visitorFormData?.visitors_management_reasons_pk}
          disabled={checkDisabled(visitorFormData?.visitors_management_reasons_pk?.visitors_management_reasons_pk)}
          loading={() => handleVisitorReasons()}
          fieldLabel="reason"
          variant={"outlined"}
          name="visitors_management_reasons_pk"
          size="small"
          onChangeEvent={(e, v) => {
            setVisitorFormData((prev) => ({ ...prev, [e]: v }));
            setErrors({});
          }}
          data={visitorReasonData}
          error={!!errors.visitors_management_reasons_pk}
          helperText={errors.visitors_management_reasons_pk || ""}
          styles={{
            "& .MuiOutlinedInput-root, & .MuiInputBase-root": {
              border: "none",
              borderBottom: "2px solid black",
              borderRadius: 0,
              fontSize: "28px",
              height: "50px",
              marginTop: "5px"
            },
            "& .MuiOutlinedInput-notchedOutline, & fieldset": {
              border: "none",
            },
            "&:hover .MuiOutlinedInput-root, &:hover .MuiInputBase-root": {
              borderBottom: "2px solid black",
            },
            "& .MuiInputLabel-root": {
              fontSize: "26px",
            },
          }}
          renderOption={(props, option) => (
            <li {...props} style={{ fontSize: "18px", padding: "5px 15px" }}>
              {option.reason}
            </li>
          )}
        />
      ),
      validate: () => visitorFormData?.visitors_management_reasons_pk,
      show: true,
    },
    {
      id: "id_proof",
      label: "ID Proof",
      component: (
        <TextField
          label="Enter ID Proof Number"
          fullWidth
          variant="standard"
          size="large"
          value={visitorFormData?.id_proof}
          onChange={(e) => {
            setVisitorFormData((prevData) => ({
              ...prevData,
              id_proof: e.target.value,
            }));
            setErrors({});
          }}
          error={!!errors.id_proof}
          helperText={errors.id_proof || ""}
          FormHelperTextProps={{
            sx: {
              marginTop: "-10px",
            },
          }}
          InputProps={{
            disableUnderline: true,
            sx: {
              fontSize: "28px",
              height: "50px",
              marginBottom: "20px",
              "&:before": {
                borderBottom: "2px solid #000",
              },
              "&:hover:not(.Mui-disabled):before": {
                borderBottom: "2px solid #1976d2",
              },
            },
          }}
          sx={{
            "& .MuiInput-root": {
              fontSize: "28px",
              height: "50px",
              borderBottom: "2px solid black",
              "&:hover:not(.Mui-disabled):before": {
                borderBottom: "2px solid blue",
              },
            },
            "& .MuiInput-underline:after": {
              borderBottom: "2px solid #1976d2",
            },
            "& .MuiInputLabel-root": {
              fontSize: "26px",
            },
          }}
        />
      ),
      validate: () => visitorFormData.id_proof.trim() !== "",
      show: visitorsExtraSettingData?.[0]?.id_proof || false,
    },
    {
      id: "vehicle_no",
      label: "Vehicle Number",
      component: (
        <TextField
          label="Enter Vehicle Number"
          fullWidth
          variant="standard"
          size="large"
          value={visitorFormData?.vehicle_no}
          onChange={(e) => {
            setVisitorFormData((prevData) => ({
              ...prevData,
              vehicle_no: e.target.value,
            }));
            setErrors({});
          }}
          error={!!errors.vehicle_no}
          helperText={errors.vehicle_no || ""}
          FormHelperTextProps={{
            sx: {
              marginTop: "-10px",
            },
          }}
          InputProps={{
            disableUnderline: true,
            sx: {
              fontSize: "28px",
              height: "50px",
              marginBottom: "20px",
              "&:before": {
                borderBottom: "2px solid #000",
              },
              "&:hover:not(.Mui-disabled):before": {
                borderBottom: "2px solid #1976d2",
              },
            },
          }}
          sx={{
            "& .MuiInput-root": {
              fontSize: "28px",
              height: "50px",
              borderBottom: "2px solid black",
              "&:hover:not(.Mui-disabled):before": {
                borderBottom: "2px solid blue",
              },
            },
            "& .MuiInput-underline:after": {
              borderBottom: "2px solid #1976d2",
            },
            "& .MuiInputLabel-root": {
              fontSize: "26px",
            },
          }}
        />
      ),
      validate: () => visitorFormData.vehicle_no.trim() !== "",
      show: visitorsExtraSettingData?.[0]?.vehicle_no || false,
    },
  ];
  const filteredSteps = steps?.filter((step) => step?.show);
  const isWhatsappFlowEnabled = filteredSteps[step]?.id === "person-to-meet" && whatsAppFlow
  const validateStep = () => {
    let newErrors = {};
    const currentStepId = filteredSteps[step]?.id;
    switch (currentStepId) {
      case "name":
        if (!visitorFormData.name.trim()) {
          newErrors.name = "Name is required.";
        } else if (/^\d+$/.test(visitorFormData.name.trim())) {
          newErrors.name = "Name can't contain only numbers.";
        }
        break;
      case "phone-number":
        if (!/^\d{10}$/.test(visitorFormData.contactno)) {
          newErrors.contactno = "Enter a valid 10-digit phone number.";
        }
        break;
      case "person-to-meet":
        if (!visitorFormData.employee_id) {
          newErrors.employee_id = "Please select a person to meet.";
        }
        break;
      case "org":
        if (!visitorFormData.multiple_org_configuration_fk) {
          newErrors.multiple_org_configuration_fk = "Please select an organization.";
        }
        break;
      case "purpose-of-visit":
        if (!visitorFormData.visitors_management_reasons_pk) {
          newErrors.visitors_management_reasons_pk = "Please select a purpose.";
        }
        break;
      case "id_proof":
        if (!visitorFormData.id_proof.trim()) {
          newErrors.id_proof = "ID Proof is required.";
        }
        break;
      case "vehicle_no":
        if (!visitorFormData.vehicle_no.trim()) {
          newErrors.vehicle_no = "Vehicle Number is required.";
        }
        break;
      default:
        break;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleResetForm = () => {
    isSubmittingRef.current = false;
    setIsSubmitting(false);
    setCheckInSuccess(false);
    setSlideMessage(null);
    handleReset();
  };


  const handleSendWhatsappInvite = async (infoData) => {
    try {
      const visitorName = infoData?.name || "Guest";
      const hostName = infoData?.employee_id?.name || "Host";
      const mobileNo = infoData?.employee_id?.whatsapp_phone_no;
      if(!mobileNo) {
        toast.error("Mobile number is missing.")
        return
      }
      const messageText = `Hi ${hostName},\n\n🔔 Visitor Check-In\n\n${visitorName} has arrived and completed the check-in process at the security gate.\n\n✅ Entry has been granted.\n\npowered by Meepl`;
      sendWhatsAppTextMessageHelper({
        number: mobileNo,
        message: messageText,
        preview_url: true,
        show: true
      });
    } catch (err) {
      console.error(err);
    }
  };

  const handleNext = () => {
    if (isSubmittingRef.current || visitorLoading) return;
    if (!validateStep()) return;
    const currentStep = filteredSteps[step]; 
    const currentLabel = currentStep?.label;
    const currentValue = (() => {
      switch (currentStep?.id) {
        case "name":
          return visitorFormData?.name || "";
        case "phone-number":
          return visitorFormData?.contactno || "";
        case "person-to-meet":
          return visitorFormData?.employee_id?.name || "";
        case "purpose-of-visit":
          return visitorFormData?.visitors_management_reasons_pk?.reason || "";
        case "id_proof":
          return visitorFormData?.id_proof || "";
        case "vehicle_no":
          return visitorFormData?.vehicle_no || "";
        case "org":
          return visitorFormData?.multiple_org_configuration_fk?.org_name || "";
        default:
          return "";
      }
    })();

    setSlideMessage(null);
    setTimeout(() => {
      setSlideMessage(`${currentLabel} : ${currentValue}`);
    }, 10);

    if (step < filteredSteps.length - 1) {
      setStep(step + 1);
    } else {
      isSubmittingRef.current = true;
      setIsSubmitting(true);
      const getLocalISOTime = () => {
        const now = new Date();
        const offsetInMinutes = now.getTimezoneOffset();
        const localTime = new Date(now.getTime() - offsetInMinutes * 60000);
        return localTime.toISOString().slice(0, -1);
      };
      const checkin_timestamp = getLocalISOTime();
      let token_id = uuidv4() + `=${domain}=inout-token`;
      const payload = {
            ...visitorFormData,
            entry_type: mode,
            domain,
            userId,
            checkin_timestamp,
            region_fk,
            visitor_type: visitorTypePopup?.type,
            token_id: token_id
          }
          dispatch(
            AddVisitorsAction(payload,
          (error, result) => {
            if (!error && result?.data?.statuscode === 200) {
              const res_data = result?.data?.data || []
              const currentData = res_data?.find(item => item.token_id === token_id) || {};
              setCheckInSuccess(true); // uncomment after sms send with link
              if (visitorFormData?.token && visitorTypePopup?.type === "Guest") {
                DeleteEmailTokenHelper({
                  domain: domain,
                  token: visitorFormData?.token,
                });
              }
              if (sendWhatsappMsg === "yes") {
                handleSendWhatsappInvite(payload);
              }
              // AddEmailTokenHelper({domain, token: token_id, json_data: JSON.stringify([ // logic is for SMS flow uncomment when we bring that SMS with link
              //   {visitors_management_pk: currentData?.visitors_management_pk,
              //     visitors_name: currentData?.visitors_name
              //   }])});
              // downloadQR({token: token_id, visitors_name: visitorFormData?.name}); // remove after sms send with link
              setTimeout(() => {
                handleResetForm(); // uncomment after sms send with link    
              }, 5000);
            } else {
              isSubmittingRef.current = false;
              setIsSubmitting(false);
              toast.error("Something went wrong");
            }
          }
        )
      );
    }
  };

  const handleBack = () => {
    if (step > 0) {
      setStep(step - 1);
      setSlideMessage(null);
    }
  };
  const qrRef = useRef(null);
  
  const downloadQR = (data) => {
    if (!data?.token) return;
    setDownloadToken(data.token);
    setDownloadName(data?.visitors_name || "visitor");
  };
// remove after sms send with link ^  and below
  useEffect(() => {
    if (!downloadToken) return;

    let attempts = 0;
    const attemptDownload = () => {
      const qrCanvas = qrRef.current?.querySelector("canvas");
      if (!qrCanvas && attempts < 10) {
        attempts += 1;
        requestAnimationFrame(attemptDownload);
        return;
      }

      if (!qrCanvas) {
        setDownloadToken("");
        setDownloadName("");
        return;
      }

      const width = 250;
      const height = 320;
      const scaleFactor = 3;
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = width * scaleFactor;
      canvas.height = height * scaleFactor;
      ctx.scale(scaleFactor, scaleFactor);

      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, width, height);
      ctx.fillStyle = "black";
      ctx.font = "18px Arial";
      ctx.textAlign = "center";
      ctx.fillText(downloadName, width / 2, 40);

      ctx.font = "16px Arial";
      ctx.fillText("Scan to In-Out", width / 2, 60);

      ctx.drawImage(qrCanvas, 25, 70, 200, 200);

      ctx.fillStyle = "grey";
      ctx.font = "bold 12px Arial";
      ctx.textAlign = "center";
      ctx.fillText("powered by Meepl", width / 2, 300);

      const url = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = url;
      link.download = `${downloadName}-in-out-qr.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setDownloadToken("");
      setDownloadName("");
      setCheckInSuccess(true);
       setTimeout(() => {
        handleResetForm();
      }, 5000);
    };

    attemptDownload();
  }, [downloadToken, downloadName]);

  const handleWhatsappRadioChange = (e) => {
    const val = e.target.value;
    if (val === "yes") {
      const configObj = whatsappConfigData?.[0] || {};
      const rawPhone = configObj?.whatsapp_business_number || "";
      let cleanPhone = String(rawPhone).replace(/[^0-9]/g, "");
      if (!cleanPhone) {
        toast.dismiss()
        toast.error("WhatsApp phone number is not configured. Please contact admin to configure it under Settings > General > Configuration.");
        setSendWhatsappMsg("no");
        return;
      }
    }
    setSendWhatsappMsg(val);
  };
  return (
    <>
      <Box
        ref={qrRef}
        sx={{
          position: "absolute",
          left: "-9999px",
          top: "-9999px",
          width: "200px",
          height: "200px",
          overflow: "hidden",
          pointerEvents: "none",
        }}
      >
        {downloadToken && (
          <QRCodeCanvas value={downloadToken} size={200} />
        )}
      </Box>
      <Box
        sx={{
        width: "100%",
        maxWidth: "500px",
        margin: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "120px",
        textAlign: "center",
      }}
    >
      <Box marginTop={"-50px"}>
        <Box sx={{ width: "1px", position: "absolute" }}>
          <IconButton edge="start" onClick={() => handleResetForm()}>
            <ArrowBackButton />
          </IconButton>
        </Box>
        <Typography variant="h4" gutterBottom>
          {filteredSteps[step].label}
        </Typography>
      </Box>
      <Box>
        <Box
          sx={{
            minHeight: "100px",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "-70px",
          }}
        >
          {slideMessage && (
            <motion.div
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 2 }}
              style={{
                position: "absolute",
                top: "-45px", 
                left: "0px",
                transform: "translateX(-50%)",
                backgroundColor: "rgb(204, 211, 224)",
                color: "black",
                padding: "10px 16px",
                borderRadius: "6px",
                fontSize: "16px",
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                zIndex: 10,
                whiteSpace: "nowrap",
                pointerEvents: "none",
              }}
            >
              {slideMessage}
            </motion.div>
          )}
          <motion.div
            key={step}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
            style={{
              position: "absolute",
              width: "100%",
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !visitorLoading && !isSubmitting) handleNext();
            }}
          >
            {filteredSteps[step].component}
          </motion.div>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            gap: "20px",
          }}
        >
          {isWhatsappFlowEnabled && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "12px", color: "#444" }}>
                Send Check-In Update via WhatsApp:
              </Typography>
              <Tooltip title="Notify the host via WhatsApp after the visitor checks in" arrow>
                <InfoOutlinedIcon sx={{ fontSize: "15px", color: "#666", cursor: "pointer" }} />
              </Tooltip>
              <RadioGroup
                row
                value={sendWhatsappMsg}
                onChange={handleWhatsappRadioChange}
                size="small"
                sx={{
                  gap: 0,
                  ml: 0.5,
                }}
              >
                <FormControlLabel
                  value="yes"
                  control={<Radio size="small" sx={{"&.Mui-checked": { color: "#fecb03" } }} />}
                  label={<Typography sx={{ fontSize: "12px", fontWeight: 500 }}>Yes</Typography>}
                  sx={{ mr: 0.5, m: 0 }}
                />
                <FormControlLabel
                  value="no"
                  control={<Radio size="small" sx={{ "&.Mui-checked": { color: "#fecb03" } }} />}
                  label={<Typography sx={{ fontSize: "12px", fontWeight: 500 }}>No</Typography>}
                  sx={{ m: 0 }}
                />
              </RadioGroup>
            </Box>
          )}
          <Button
            onClick={handleBack}
            disabled={step === 0 || visitorLoading || isSubmitting}
            variant="contained"
            sx={{
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "12px",
              backgroundColor: "#fecb03",
              visibility: step === 0 ? "hidden" : "visible",
              minWidth: "unset",
              "&:hover": {
                backgroundColor: "#fecb03",
              },
              "&.Mui-disabled": {
                backgroundColor: "#fecb03",
                opacity: 0.7,
              },
            }}
          >
            <ArrowForwardIosIcon
              sx={{
                fontSize: "28px",
                color: "black",
                transform: "rotate(180deg)",
              }}
            />
          </Button>
          <Button
            onClick={() => !visitorLoading && !isSubmitting && handleNext()}
            disabled={visitorLoading || isSubmitting}
            variant="contained"
            sx={{
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "12px",
              backgroundColor: "#fecb03",
              minWidth: "unset",
              "&:hover": {
                backgroundColor: "#fecb03",
              },
              "&.Mui-disabled": {
                backgroundColor: "#fecb03",
                opacity: 0.7,
              },
            }}
          >
            {step < filteredSteps.length - 1 ? (
              <ArrowForwardIosIcon sx={{ fontSize: "28px", color: "black" }} />
            ) : (
              <>
                {visitorLoading || isSubmitting ? (
                  <CircularProgress size={28} sx={{ color: "black" }} />
                ) : (
                  <CheckIcon sx={{ fontSize: "32px", color: "black" }} />
                )}{" "}
              </>
            )}
          </Button>
        </Box>
      </Box>
    </Box>
    </>
  );
};

export default TypeformReplica;
